// extracted by mini-css-extract-plugin
export default {"wrapper":"AnimatedPieChart_wrapper__hrZft"};